import { ModuleScheduleSection, type User } from '@common/clients/api/types.gen';
import { type ResolvedContextData } from '@common/defaults/ContextData';
import { DateTimeDuration } from '@common/utils/DateTimeDuration';

type UserBettingProps = Pick<User, 'bettingEnabled' | 'birthDate'>;

const isUserOver24 = (user: UserBettingProps): boolean => {
    const age = new DateTimeDuration(new Date(user.birthDate!));
    return age.years >= 24;
};

export const isBettingDisabledForUser = (user?: UserBettingProps): boolean => {
    const isOver24 = user?.birthDate ? isUserOver24(user) : undefined;
    return isOver24 === false || user?.bettingEnabled === false;
};

export const checkIfBettingScheduled = (
    modulesBySection: ResolvedContextData['modulesBySection'],
): boolean => {
    if (!modulesBySection) return false;
    for (const key of Object.values(ModuleScheduleSection)) {
        const isExcluded: ModuleScheduleSection[] = [
            ModuleScheduleSection.NATIONAL_THEME,
            ModuleScheduleSection.LIVESTREAM,
            ModuleScheduleSection.TAG_SPONSORSHIP,
        ];

        if (isExcluded.includes(key)) {
            continue;
        }

        const value = modulesBySection[key];
        if (value?.length) return true;
    }
    return false;
};
